<script>
import RequestAgentKitDialog from "@/components/common/requestAgentKitDialog.vue";

export default {
  name: "agentRegistrationSection3",
  data() {
    return {
    };
  },

}
</script>

<template>
    <div class="benefits-section">
      <el-row class="benefits-section-inner" type="flex" align="middle">
        <!-- Left Column - Text Content -->
        <el-col :xs="24" :sm="12">
          <h2 class="section-title">Platform Benefits for Agents</h2>

          <div class="benefit-item">
            <h3 class="benefit-item-title">Increased Visibility:</h3>
            <p class="benefit-item-description">Our platform is tailored to highlight new projects, giving you access to a growing pool of buyers interested in off-the-plan properties.</p>
          </div>

          <div class="benefit-item">
            <h3 class="benefit-item-title">High-Quality Leads:</h3>
            <p class="benefit-item-description">With customizable search filters, buyers are matched with the properties that best meet their criteria, ensuring your listings reach the most relevant audience.</p>
          </div>

          <div class="benefit-item">
            <h3 class="benefit-item-title">Comprehensive Data Insights:</h3>
            <p class="benefit-item-description">Every listing includes detailed information, including rental appraisals and specifications guides, helping you deliver a seamless, informative buying experience.</p>
          </div>
        </el-col>

        <!-- Right Column - Image -->
        <el-col class="image-container-wrapper" :xs="24" :sm="12">
          <div class="image-container">
            <img
                src="../../../assets/agent-section-3-page-background.png"
                alt="Blueprint review process"
                class="feature-image"
            >
          </div>
        </el-col>
      </el-row>
    </div>

</template>

<style scoped lang="scss">
.benefits-section {
  padding: 20px 20px;
}
.benefits-section-inner {
  padding: 0 20px;
}

.section-title {
  color: #003333;
  font-size: 22px;
  margin-bottom: 40px;
  font-weight: 600;
}

.benefit-item {
  margin-bottom: 30px;
}

.benefit-item-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}

.benefit-item-description {
  color: #003333;
  font-size:18px;
  line-height: 1.6;
  margin: 0;
}
.image-container-wrapper {
  display: flex;
  justify-content: center;
}
.image-container {
  width: 90%;
  height: 100%;
  overflow: hidden;
}

.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 768px) {
  .benefits-section-inner {
    display: flex;
    flex-direction: column;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationSection3.vue